import { render, staticRenderFns } from "./CompaniesForm.vue?vue&type=template&id=343b8a46&"
import script from "./CompaniesForm.vue?vue&type=script&lang=js&"
export * from "./CompaniesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports